import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import AsyncStorage from '@react-native-async-storage/async-storage'

// gloabal types
import { PersonalData } from '../types/personalTypes'

// helpers
import { delayHttpRequest } from '../helpers/globalHelper'

// services
import { personalService } from '../services/personalService'

// stores
import { useHomeStore } from './home'

// types
type Store = {
  personalData: PersonalData
  loading: boolean
  updatedData:any
  error: string | null
  clearData: () => void
  fetchData: (id: number) => void
  updateData: (id: number, feed: PersonalData) => void
  updatepersonalinformation:(data)=>void
  getUpdatedData:(essuserkey:number)=>void
  getDisablekeys:(entityid : number)=> void
  disablekeysData:any
}

const usePersonalStore = create(
  devtools<Store>((set) => ({
    personalData: null,
    loading: false,
    error: null,
    disablekeysData:null,
    updatedData:null,
    clearData: () => set({ personalData: null, loading: false, error: null }),
    fetchData: async (id) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        const _personalData = await personalService.fetchData(id)
        set((state) => ({ ...state, personalData: _personalData }))
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    updateData: async (id, feed) => {
      set((state) => ({ ...state, loading: true }))
      try {
        const _personalData = await personalService.updateData(id, feed)
        set((state) => ({ ...state, personalData: _personalData }))

        // fetch home data
        useHomeStore.getState().fetchData(id)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    updatepersonalinformation:async(data)=>{
      set((state)=>({...state,loading:true}))
      try{
        return await personalService.updatepersonalinformation(data)
      }
      catch(err){
          set((state)=>({...state,error:err.message}))
      }finally{
        set((state)=>({...state,loading:false}))
      }
    },
    getUpdatedData:async(essuserkey:number)=>{
      set((state)=>({...state,loading:true}))
      try{
        const _data=await personalService.getUpdatedData(essuserkey)
        set((state)=>({...state,updatedData:_data}))
      }
      catch(err){
        set((state)=>({...state,error:err.message}))
      }finally{
        set((state)=>({...state,loading:false}))
      }
    },
    getDisablekeys:async(entityid:number)=> {
      set((state) => ({...state,loading:true}))
      try{
        const _data= await personalService.getDisablekeys(entityid)
        set((state)=>({...state,disablekeysData:_data}))
      }
      catch(err){
        set((state)=>({...state,error:err.message}))
      }finally{
        set((state)=>({...state,loading:false}))
      }
    }
  }))
)

export { usePersonalStore }
